module.exports = __webpack_public_path__ + "media/home/BrowseProducts-604558ff.jpg";